import { postData, getData, patchData, deleteData } from "../api/api";

export type ExportScheduleFrequency = "DAILY" | "WEEKLY";
export type ExportDateRangePreset = "LAST_7D" | "LAST_30D" | "THIS_MONTH";

export type DashboardExportSchedule = {
  id?: string;
  dashboardId: string;
  dashboardName?: string;
  frequency?: ExportScheduleFrequency;
  hourUtc?: number;
  dayOfWeek?: string;
  dateRangePreset?: ExportDateRangePreset;
  recipientEmails?: string[];
  active?: boolean;
  lastRunAt?: string;
  nextRunAt?: string;
  lastError?: string;
};

const BASE = "/dashboards/export-schedules";

export const dashboardExportScheduleService = {
  list: () => getData(BASE) as Promise<DashboardExportSchedule[]>,
  create: (schedule: DashboardExportSchedule) =>
    postData(BASE, schedule) as Promise<DashboardExportSchedule>,
  update: (id: string, schedule: Partial<DashboardExportSchedule>) =>
    patchData(`${BASE}/${id}`, schedule) as Promise<DashboardExportSchedule>,
  remove: (id: string) => deleteData(`${BASE}/${id}`),
};
